import { AxiosInstance } from "axios";

export const createApiTr3 = (axios: AxiosInstance) => {
  return {
    verifyCode: (code: string) =>
      axios.get<{ email: string }>(`/activation_code/verify/${code}/`),
    verifySms: (code: string) =>
      axios.post("/auth/send_onetime_auth_sms/", {
        otp_code_id: code
      }),
    passwordResetValidate: (hash: string) =>
      axios.get(`/password/reset/${hash}/`),
    passwordReset: ({
      hash,
      password,
      password_confirm
    }: {
      hash: string;
      password: string;
      password_confirm: string;
    }) =>
      axios.post(`/password/reset/${hash}/`, {
        password,
        password_confirm
      })
  };
};
